// styles
import './css/libs.scss';
import './css/style.scss';

// libraries
import 'jquery-match-height/dist/jquery.matchHeight-min';
import './js/popper.min';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap-select/dist/js/bootstrap-select.min';
import 'slick-carousel/slick/slick';
import 'superfish/dist/js/hoverIntent';
import 'superfish/dist/js/superfish.min';
import 'superfish/dist/js/supersubs';
import 'aos/dist/aos';
import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'waypoints/lib/noframework.waypoints';

// helpers
import './js/helpers/svg.explode';
import './js/helpers/mutations';
import './js/helpers/responsive.iframe.video';
import './js/helpers/counterup.animation';
import './js/helpers/fill.media.to.container';

// admin scripts
import './js/admin/status.messages';

// component scripts and globals
import './js/components/back.to.top';
import './js/components/sticky.header';
import './js/components/main-navigation';
import './js/components/newsletter-toggle';
import './js/components/accordion';
import './js/components/sliders';
import './js/components/banner-landing-page';
import './js/components/magnific.popup';
import './js/components/video-hover';
import './js/components/jump-links';
import './js/components/asset-download';
import './js/components/asset-download-page';
import './js/components/case-study-filters';
import './js/components/timeline';
import './js/components/solutions.overview';
import './js/components/campaign.page.cta';
import './js/components/tabs.contact.us';
import './js/components/tabs'; // needs to go after fill.media.to.container.js
import './js/forms';
import './js/globals';
import './js/components/sidebar.navigation'; // needs to be to loaded after globals.js
import './js/maps/BcpAlertBar';

// get all images
require.context("./images/", true, /\.(jpe?g|png|gif|svg)$/);
